import { MarketSortOption } from '@/constants/sort';
import { ReqGetNewProducts } from '@/service/market/new/getNewProducts';

export const RQNewKey = {
  newHomeProducts: ['main', 'new'] as const,
  newPageProducts: (query: ReqGetNewProducts['query'], sortOption: MarketSortOption | null) =>
    ['new', JSON.stringify(query), sortOption] as const,
};
